export default __webpack_public_path__ + "static/media/02.9b3f3110.gif";